import React, { Fragment } from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import DashboardIcon from '@material-ui/icons/Dashboard'
import HelpIcon from '@material-ui/icons/Help'
import NotificationsIcon from '@material-ui/icons/Notifications'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { Link } from 'react-router-dom'

export const mainListItems = (
  <Fragment>
    <Link to='/' style={{ color: 'inherit', textDecoration: 'inherit' }}>
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary='Anasayfa' />
      </ListItem>
    </Link>
    <Link
      to='/questions'
      style={{ color: 'inherit', textDecoration: 'inherit' }}
    >
      <ListItem button>
        <ListItemIcon>
          <HelpIcon />
        </ListItemIcon>
        <ListItemText primary='Soru Ekle/Çıkar' />
      </ListItem>
    </Link>
      <Link
          to='/lastquestions'
          style={{ color: 'inherit', textDecoration: 'inherit' }}
      >
          <ListItem button>
              <ListItemIcon>
                  <HelpOutlineIcon />
              </ListItemIcon>
              <ListItemText primary='Son Sorular' />
          </ListItem>
      </Link>
    <Link
      to='/notifications'
      style={{ color: 'inherit', textDecoration: 'inherit' }}
    >
      <ListItem button>
        <ListItemIcon>
          <NotificationsIcon />
        </ListItemIcon>
        <ListItemText primary='Bildirimler' />
      </ListItem>
    </Link>
  </Fragment>
)
